import PropTypes from 'prop-types';
import React from 'react';

function TwitterSVG({ width, height, fill }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3899 3.31746V3.75397C14.3899 7.94444 11.0692 12.5714 5.03145 12.5714C3.1195 12.5714 1.40881 12.2222 0 11.3492C0.301887 11.3492 0.503145 11.4365 0.805032 11.4365C2.31447 11.4365 3.8239 10.9127 4.93082 10.0397C3.52201 10.0397 2.31447 9.07936 1.81132 7.85714C2.01258 7.85714 2.21384 7.94444 2.41509 7.94444C2.71698 7.94444 3.1195 7.94444 3.42138 7.85714C1.81132 7.50794 0.905661 6.19841 0.905661 4.62698C0.905661 4.88889 1.61006 4.97619 2.11321 5.06349C1.20755 4.45238 0.704403 3.49206 0.704403 2.44444C0.704403 1.83333 0.805032 1.30952 1.10692 0.873016C2.71698 2.79365 5.03145 4.01587 7.74843 4.19048V3.40476C7.74843 1.65873 9.25786 0 11.0692 0C11.9748 0 12.8805 0.611111 13.4843 1.22222C14.1887 1.04762 14.8931 0.785714 15.5975 0.436508C15.3962 1.13492 14.7925 1.83333 14.1887 2.18254C14.7925 2.09524 15.3962 1.92063 16 1.65873C15.5975 2.35714 14.9937 2.88095 14.3899 3.31746Z"
        fill={fill}
      />
    </svg>
  );
}

TwitterSVG.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};

export default TwitterSVG;
